module.exports = __webpack_public_path__ + "static/media/FSA-HSA_icon_long.4b5f446d.svg";